import { checkout } from 'utils/checkout';

const CustomPlans = () => {
  checkout('price_1NVGLuLVMiFmGBXgfBsJdUCH');
};

export default CustomPlans;
